var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.92969C2.94772 4.92969 2.5 5.3774 2.5 5.92969V17.9297C2.5 18.482 2.94772 18.9297 3.5 18.9297H21.5C22.0523 18.9297 22.5 18.482 22.5 17.9297V5.92969C22.5 5.3774 22.0523 4.92969 21.5 4.92969H3.5ZM0.5 5.92969C0.5 4.27283 1.84315 2.92969 3.5 2.92969H21.5C23.1569 2.92969 24.5 4.27283 24.5 5.92969V17.9297C24.5 19.5865 23.1569 20.9297 21.5 20.9297H3.5C1.84315 20.9297 0.5 19.5865 0.5 17.9297V5.92969Z",
    fill: "#2A184B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 9.92969C0.5 9.3774 0.947715 8.92969 1.5 8.92969H23.5C24.0523 8.92969 24.5 9.3774 24.5 9.92969C24.5 10.482 24.0523 10.9297 23.5 10.9297H1.5C0.947715 10.9297 0.5 10.482 0.5 9.92969Z",
    fill: "#2A184B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.4449994b.svg";
export { ForwardRef as ReactComponent };